import React from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';

export default function EmailActivityFilters({ dateFilter, onDateFilterChange }) {
  const filters = [
    { value: 'all', label: 'All Time' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '7days', label: 'Last 7 Days' },
    { value: 'today', label: 'Today' }
  ];

  return (
    <Box display="flex" justifyContent="flex-end">
      <ButtonGroup variant="outlined" size="small">
        {filters.map((filter) => (
          <Button
            key={filter.value}
            onClick={() => onDateFilterChange(filter.value)}
            variant={dateFilter === filter.value ? 'contained' : 'outlined'}
          >
            {filter.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
}